import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { authHeader } from "@/utils/headers";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { useUserToken } from "@/context/auth-context";

export interface MCPFunction {
  name: string;
  description: string;
  input_schema: Record<string, object>;
}

export const useListMCPFunctions = (
  serverUrl: string | undefined,
  headers: Record<string, string> | undefined,
) => {
  const userToken = useUserToken();

  const headerKey =
    headers === undefined
      ? ""
      : Object.entries(headers)
          .map(header => header[0] + "=" + header[1])
          .join("&");

  return useQuery<MCPFunction[], Error>({
    queryKey: ["listMCPFunctions", serverUrl, headerKey],
    enabled: !!serverUrl,
    retry: false,
    queryFn: async () => {
      try {
        const url = new URL(ENDPOINTS.list_mcp_functions);
        const response = await fetch(url.toString(), {
          method: "POST",
          headers: authHeader(userToken),
          body: JSON.stringify({
            server_configuration: {
              server_url: serverUrl,
              headers: headers,
            },
          }),
        });
        // handleResponse may throw, so wrap in try/catch
        return await handleResponse(response);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        // Ensure error is always an Error instance
        if (error instanceof Error) {
          throw error;
        } else {
          throw new Error(typeof error === "string" ? error : "Failed to fetch MCP functions");
        }
      }
    },
  });
};
